var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('excise-transactions',{attrs:{"listObject":"nonExcise","objectId":_vm.nonExciseId,"back":[{text:'Non-excises',to:{name:'AlcoholNonExcises'}}],"contents":false,"vessel":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }